import en from './en/common.json';
import fr from './fr/common.json';

const locales = {
  en: { translation: en },
  fr: { translation: fr },
};

export default locales;
